(function() {
  'use strict';
  
  angular
    .module('app.poll')
    .controller('PollController', PollController);
    
  
  PollController.$inject = [
    '$log', 
    '$mdDialog',
    '$scope',
    '$state',
    '$stateParams',
    'auth',
    'shell',
    'plugins', 
    'PLUGIN_ACTIONS',
    'pollService',
  ];
  
  function PollController(
      $log, 
      $mdDialog,
      $scope, 
      $state, 
      $stateParams, 
      auth, 
      shell,
      plugins, 
      PLUGIN_ACTIONS, 
      pollService
    ) {
    $log = $log.getInstance('PollController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.isPoller = false
    vm.logout = logout;
    vm.multiplePollsActive = false;
    vm.nextPoll = nextPoll;
    vm.goToPresenterMode = goToPresenterMode;
    vm.showMyDisplayNameDialog = showMyDisplayNameDialog;
    vm.showMyFeedsDialog = showMyFeedsDialog;
    vm.showSubscribeDialog = showSubscribeDialog;
    
    activate();
    
    function activate() {
      auth.isAuthenticated().then(function(user) {
        vm.isPoller = (user.group === 'poller');
        var userMenuItems = [
          {
            label: 'My Display Name',
            icon: 'face',
            callback: showMyDisplayNameDialog
          },
          {
            label: 'My Feeds',
            icon: 'playlist_add',
            callback: showMyFeedsDialog
          }
        ];
        if (vm.isPoller) {
          userMenuItems.unshift({
            label: 'Presenter Mode',
            icon: 'insert_chart',
            callback: goToPresenterMode
          });
        }
        shell.setTitle('Mars');
        shell.setToolbar([{
          label: 'Join Feed',
          icon: 'add',
          callback: showSubscribeDialog
        }]);
        shell.setUserMenu(userMenuItems);
        shell.setAction('Loading');
        pollService.onActivePollsChanged($scope, _onActivePollsChanged);
        pollService.getActivePolls()
          .then(function() {
            shell.clearAction();
          });
      }).catch(function(err) {
        return $state.go('auth.login');
      });

      pollService.getSubscriptions()
      .then(function(subscriptions) {
        if (subscriptions.length === 0)
          showUserAgreement();
      });
    }
    
    function logout() {
      $state.go('auth.logout');
    }
    
    function nextPoll() {
      var active = pollService.nextActivePoll();
      _viewPoll(active);
    }
    
    function goToPresenterMode() {
      $state.go('shell.myPolls');
    }
    
    function showMyDisplayNameDialog() {
      $mdDialog.show({
        templateUrl: 'app/poll/my-display-name.html',
        controller: 'MyDisplayNameController as vm',
        clickOutsideToClose: true,
        fullscreen: true
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }
    
    function showMyFeedsDialog() {
      $mdDialog.show({
        templateUrl: 'app/poll/my-feeds.html',
        controller: 'MyFeedsController as vm',
        clickOutsideToClose: true,
        fullscreen: true
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }
    
    function showSubscribeDialog(event) {
      $mdDialog.show({
        templateUrl: 'app/poll/poll.subscribe.html',
        controller: 'PollSubscribeController as vm',
        clickOutsideToClose: true,        
        targetEvent: event
      }).then(function() {
        pollService.getActivePolls();
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }

    function showUserAgreement() {
      $mdDialog.show(
        $mdDialog.confirm()
        .title('User Agreement')
        .htmlContent(
          '<p>' +
          '  The information you provide may be used and published in an aggregated format. No individual or their response will be published.' +
          '</p>' +
          '<p>' +
          '  For information regarding how your personal information is handled, please refer to the <a href="http://privacy.monash.edu.au/guidelines/collection-personal-information.html#enrol">Student Privacy Collection Statement</a>.' +
          '</p>'
        )
        .ariaLabel('User Agreement')
        .ok('Accept')
      )
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop); 
    }
    
    function _onActivePollsChanged(event, count) {
      var active = pollService.activePoll();
      $log.debug('Active poll: ', active);
      _viewPoll(active);
      vm.multiplePollsActive = count > 1;
    }
    
    function _viewPoll(result) {
      if (result === null) {
        vm.poll = null;
        vm.result = null;
        shell.setTitle('Mars');
      }
      else {
        vm.poll = result.poll;
        vm.result = result;
        shell.setTitle(result.poll.pollCollection.name);
      }
    }
    
  }
  
})();